var metaConfig = {
    title: "University of Guelph Library",
    description: "McLaughlin Library",
    url: process.env.URL,
    author: "@uglibrary",
    ogImage: "https://www.uoguelph.ca/img/uofg-cornerstone.jpg",
	ogImageAlt: "University of Guelph logo",
    GAtrackingID: "UA-163692-5",
    IGuser: "uglibrary",
    menus: ["main", "footer", "library-quick-links"],
    sitemap: {
        frequent: [
            '/',
            '/news/'
        ]
    }
};

module.exports = metaConfig;